<template>
  <div class="authLayout authLayout_fullWidth">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
  data: () => ({
    snackbar: false,
    snackText: '',
  }),
  computed: {
    routeName() {
      return this.$route.name;
    },
    shouldFitHeight() {
      return !(this.routeName || '').startsWith('help');
    },
  },
  watch: {
    snack(val) {
      this.snackText = val[val.length - 1];
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss">
.authLayout {
}
</style>
